//引入组件
import InsureInfoDetail from './src/components/InsureInfoDetail.vue'
import InsureInfoDetailCustom from './src/components/InsureInfoDetailCustom.vue'
import InsureNotices from './src/components/InsureNotices.vue'
import InsureProductItem from './src/components/InsureProductItem.vue'
import BaseHintDialog from './src/components/dialog/baseHintDialog.vue'
import BaseFormDialog from './src/components/dialog/baseFormDialog.vue'
import JianzhuHintDialog from './src/components/dialog/jianzhuHintDialog.vue'
import dialogGetiHint from './src/components/dialog/dialogGetiHint.vue'
import xsmYinLiuDialog from './src/components/dialog/xsmYinLiuDialog.vue'
import dialogRepeatEmps from './src/components/dialog/dialogRepeatEmps.vue'
import dialogPayerInfo from './src/components/dialog/dialogPayerInfo.vue'

// const componentsList = [InsureInfoDetail, InsureNotices, InsureProductItem]
//
// //批量组件注册
// const install = (Vue) => {
//   componentsList.forEach((com) => {
//     if (install.installed) {
//       return
//     }
//     install.installed = true
//     Vue.component(com.name, com)
//   })
// }
//
// if (typeof window !== 'undefined' && window.Vue) {
//   install(window.Vue)
// }

export {
	InsureInfoDetail,
	InsureInfoDetailCustom,
	InsureNotices,
	InsureProductItem,
	BaseHintDialog,
	BaseFormDialog,
	JianzhuHintDialog,
	dialogGetiHint,
	xsmYinLiuDialog,
	dialogRepeatEmps,
	dialogPayerInfo,
}
